import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingModule } from 'ngx-loading';
import { SharedModule } from '../../shared/shared.module';
import { AlertsComponent } from './alerts.component';
import { AlertsService } from './alerts.service';
import { AlertsCreateDialogComponent } from './alerts-create-dialog/alerts-create-dialog.component';
import { FormsModule } from '@angular/forms';
import { MatSelectModule, MatTooltipModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    LoadingModule,
    SharedModule,
    FormsModule,
    MatSelectModule,
    MatTooltipModule
  ],
  entryComponents: [
    AlertsCreateDialogComponent
  ],
  declarations: [
    AlertsComponent,
    AlertsCreateDialogComponent,
  ],
  providers: [AlertsService]
})
export class AlertsModule { }



// WEBPACK FOOTER //
// ./src/app/entities/alerts/alerts.module.ts